export const DoppeActionTypeContactFormViewerLang = {
    defaultTexts: {
        subscribeButtonText: 'Subscribe'
    }
}